/*
 * press-kit.js — press kit page behaviour (sections/press-kit-files.liquid, sections/press-kit-videos.liquid).
 * Downloads: files live on another domain (Shopify's and Videowise's CDNs), where browsers ignore the download attribute
 * and open the file in a tab. So [data-pk-download] fetches the file and saves it under its friendly name. If that
 * fails, or the file is too big to hold in memory, the link's normal behaviour (open in a new tab) takes over.
 * Video cards: [data-pk-play] swaps the picture for the player, so nothing from YouTube loads until someone presses play.
 * Pop-ups: none on this page, see noPopups below.
 * Listens on the document, so it keeps working when the theme editor re-renders a section.
 */
(function () {
  /* every band on the page loads this file, so only the first copy sets anything up */
  if (window.pressKitReady) return;
  window.pressKitReady = true;

  var MAX_SAVE_BYTES = 500 * 1024 * 1024;
  /* Shopify's CDN answers a JPG request for a see-through WebP with a PNG, so the saved name follows what actually arrived */
  var IMAGE_EXTENSIONS = { 'image/png': 'png', 'image/jpeg': 'jpg' };

  function fileName(link, blob) {
    var name = link.getAttribute('data-pk-download');
    var extension = IMAGE_EXTENSIONS[blob.type];
    return extension ? name.replace(/\.[^.]+$/, '.' + extension) : name;
  }

  function saveBlob(blob, filename) {
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 10000);
  }

  function download(link) {
    var label = link.querySelector('[data-pk-label]');
    var idleText = label.textContent;
    link.setAttribute('aria-busy', 'true');
    label.textContent = link.getAttribute('data-busy-label');

    fetch(link.href)
      .then(function (response) {
        var size = Number(response.headers.get('content-length'));
        if (!response.ok || size > MAX_SAVE_BYTES) throw new Error('open in a tab instead');
        return response.blob();
      })
      .then(function (blob) { saveBlob(blob, fileName(link, blob)); })
      .catch(function () { window.open(link.href, '_blank', 'noopener'); })
      .finally(function () {
        link.removeAttribute('aria-busy');
        label.textContent = idleText;
      });
  }

  function play(button) {
    var media = button.parentElement;
    var player;
    if (button.hasAttribute('data-youtube')) {
      player = document.createElement('iframe');
      player.src = 'https://www.youtube-nocookie.com/embed/' + button.getAttribute('data-youtube') + '?autoplay=1&rel=0&playsinline=1';
      player.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
      player.allowFullscreen = true;
      player.title = button.getAttribute('aria-label');
    } else {
      player = document.createElement('video');
      player.src = button.getAttribute('data-video');
      player.controls = true;
      player.autoplay = true;
      player.playsInline = true;
    }
    media.replaceChildren(player);
    player.focus();
  }

  /* No sales pop-ups on the press kit: journalists come for files. Same approach as assets/geo-upgrade.js. The Getsitecontrol
     app loads its own script on every page, whatever layout/theme.liquid does, and its widget forces itself visible over CSS,
     so it's taken out as it arrives. An open pop-up also stops the page scrolling (overflow on <html>, plus a
     getsitecontrol-<id>-open class on <body>) until its own close button is used, so the lock has to go with it. */
  function noPopups() {
    var root = document.documentElement;
    var body = document.body;
    function clear() {
      document.querySelectorAll('getsitecontrol-widget').forEach(function (widget) { widget.remove(); });
      var open = Array.prototype.filter.call(body.classList, function (name) { return /^getsitecontrol-\d+-open$/.test(name); });
      if (!open.length || !root.style.overflow) return; /* the class and the lock don't arrive together: this runs for each */
      open.forEach(function (name) { body.classList.remove(name); });
      root.style.removeProperty('overflow');
    }
    clear();
    new MutationObserver(clear).observe(root, { childList: true, subtree: true });
    var lockWatch = new MutationObserver(clear);
    lockWatch.observe(root, { attributes: true, attributeFilter: ['style'] });
    lockWatch.observe(body, { attributes: true, attributeFilter: ['class'] });
  }
  noPopups();

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-pk-download]');
    if (link) {
      if (event.metaKey || event.ctrlKey || event.shiftKey) return;
      event.preventDefault();
      if (link.getAttribute('aria-busy') !== 'true') download(link);
      return;
    }
    var button = event.target.closest('[data-pk-play]');
    if (button) play(button);
  });
})();
